export default __webpack_public_path__ + "static/DSC_0031-76c515e2bd9a25cfca644d4053de053d.jpg";